export function findReactSelectOption({
  value,
  options,
}: {
  value: any
  options: { label: string; value: any }[]
}) {
  return options.find(option => option.value === value)
}
